import FacebookTargeting from '@/descriptors/FacebookTargeting.js';
import AdAccount from '@/entities/AdAccount.js';
import BaseEntity from '@/entities/BaseEntity.js';
import ConnectedProfile from '@/entities/ConnectedProfile.js';
import SourceProfile from '@/entities/SourceProfile.js';

export default class Brand extends BaseEntity {
  id = null;
  name = null;
  meta_ad_account = null;
  facebook_source_profile = null;
  instagram_source_profile = null;
  token_expired = false;
  related_connected_profile = null;
  blocked_routes = [];
  send_weekly_report = false;
  weekly_report_day = null;
  weekly_report_to = [];
  weekly_report_emails = null;
  website = null;
  target_audience = null;
  targeting = null;
  meta_verified_advertiser_beneficiary_id = null;
  meta_verified_advertiser_payer_id = null;
  rules = [];
  rules_count = 0;
  is_managed = false;
  is_active = true;
  deactivated_at = null;
  created_at = null;
  deleted_at = null;

  _entityFields = {
    meta_ad_account: AdAccount,
    facebook_source_profile: SourceProfile,
    instagram_source_profile: SourceProfile,
    related_connected_profile: ConnectedProfile,
    targeting: FacebookTargeting,
  };

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }

  get sourceProfiles() {
    return [ this.facebook_source_profile, this.instagram_source_profile ].filter(Boolean);
  }

  get isInactive() {
    return this.is_active === false;
  }
}
